
  import Events from '@/events/Events';
  import JobBoxAlert from '@/components/JobBoxAlert';
  import jobsSearchUrlHelper from '@/helper/jobsSearchUrlHelper';

  export default {
    name: 'OrganizationJobPostings',
    components: {
      Pagination: () => import('@/components/Pagination'),
      JobBoxAlert,
    },
    props: {
      organization: {
        type: Object,
        require: true,
        default: () => {},
      },
      numJobPostings: {
        type: Number,
        required: false,
        default: 5,
      },
      activities: {
        type: String,
        required: false,
        default: null,
      },
      latitude: {
        type: Number,
        required: false,
        default: null,
      },
      longitude: {
        type: Number,
        required: false,
        default: null,
      },
      distance: {
        type: Number,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        page: 1,
        jobPostings: [],
      };
    },
    async fetch() {
      let cacheKey = 'OrganizationJobPostings';
      cacheKey += '_' + this.organization.id;

      // Add activities as get-parameter
      const getParameters = new URLSearchParams();

      getParameters.append('op_id', this.organization.id);

      this.jobPostings = await this.$cache.cache(
        cacheKey,
        () => {
          return this.$store
            .dispatch('api/jobPosting/getJobPostings', getParameters)
            .then((x) => x.data);
        },
        parseInt(process.env.NUXT_ENV_LOCALFORAGE_CACHE_TTL ?? 0)
      );
    },
    computed: {
      visibleJobs() {
        const jobs = this.jobPostings.slice(
          (this.page - 1) * this.numJobPostings,
          this.page * this.numJobPostings
        );
        let items = [];
        if (process.client && jobs) {
          items = jobs.map((item, key) => ({
            id: item.id,
            position: key + 1,
          }));
          this.$emitWithClientData(Events.JobBoxViewed, {
            boxType: 'OrganizationOffers',
            items,
          });
        }
        return jobs;
      },
    },
    methods: {
      jobsSearchUrl() {
        let filterParams = {};
        if (this.organization) {
          filterParams = {
            op_id: this.organization.id,
          };
        }
        return jobsSearchUrlHelper(
          filterParams,
          this.$auth.loggedIn,
          this.$auth.user?.candidateProfile?.addresses[0]
        );
      },
    },
  };
